import { HUB, SHOP, WAREHOUSE } from '../constants'

export const getAssocitionName = (type: string) =>
  type === SHOP ? 'magazin' : type === HUB ? 'hub' : type === WAREHOUSE ? 'depozit' : ''
